import $ from 'jquery';
import { deleteTagImage } from './deleteTagImage';

export const onclickDeleteImageTag = (event) => {
  const sidebarCurrentImagesTagItemId = $(event.currentTarget).data(
    'delete-image-id'
  );
  const isUserOwner = $(event.currentTarget).data('delete-tag-user-owner');
  const sidebarCurrentTagItemId = $(event.currentTarget).data('delete-tag-id');
  deleteTagImage(
    sidebarCurrentImagesTagItemId,
    sidebarCurrentTagItemId,
    isUserOwner
  );
};
